let keyHandling = function (Key, callback) {
    Key == 'Enter' ? callback() : '';

}


export default keyHandling